// removed by extract-text-webpack-plugin
module.exports = {"gwGtpPresentationArea":"GuidanceMediaArea-hashed__gwGtpPresentationArea__23m8z"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/directives/MediaArea/GuidanceMediaArea-hashed.scss
// module id = 682
// module chunks = 0